export const calcEhpPath = '/calc/ehp';
export const calcBuffDurationPath = '/calc/buffduration';
export const questTrackerPath = '/questtracker';
export const mapSelectorPath = '/maps';
export const questItemsPath = '/questitems';
export const kitBuilderPath = '/kitBuilder';
